import LegalDocumentPage from "../components/legal/LegalDocumentPage";

const TermsOfUse = () => <LegalDocumentPage documentKey="termsOfUse" />;

export default TermsOfUse;
